var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "multiple-upload" },
    [
      _c(
        "el-input",
        {
          attrs: {
            placeholder: _vm.placeholder,
            value: _vm.fileName,
            readonly: "readonly",
            disabled: _vm.disabled,
          },
        },
        [
          _c(
            "template",
            { slot: "append" },
            [
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo",
                  attrs: {
                    "on-success": _vm.onSuccess,
                    "on-error": _vm.onError,
                    action: _vm._action,
                    "show-file-list": false,
                    "list-type": "text",
                    data: _vm.params,
                    "before-upload": _vm.beforeUpload,
                    loading: _vm.loading,
                    "on-change": _vm.fileChange,
                    "file-list": _vm.fileList,
                    accept: _vm.accept,
                    disabled: _vm.disabled,
                    "with-credentials": "",
                    limit: _vm.limit,
                    multiple: _vm.multiple,
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { color: "#1fa0e8" },
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading: _vm.loading,
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("components.upload.uploadField")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }